import { lazy } from "react";

export const ReviewsAsync = lazy(() => import("./Reviews"));
